import React from 'react';
import './DeleteConfirmationModal.css';

interface DeleteConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  text: string;
  loading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  onConfirm,
  onCancel,
  text,
  loading,
}) => {
  return (
    <div className='delete-conf-modal-overlay'>
      <div className='delete-conf-modal'>
        <h3>{text}</h3>
        <hr className='delete-conf-modal-separator' />
        <div className='delete-conf-modal-buttons'>
          <button onClick={onCancel}>ביטול</button>
          <button className='danger' onClick={onConfirm} disabled={loading}>
            מחק
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
